import axios from "axios";
import {
    GROCERY_V2_ITEM_GET_REQUEST,
    GROCERY_V2_ITEM_GET_SUCCESS,
    GROCERY_V2_ITEM_GET_FAIL,
    GROCERY_V2_ITEM_CREATE_REQUEST,
    GROCERY_V2_ITEM_CREATE_SUCCESS,
    GROCERY_V2_ITEM_CREATE_FAIL,
    GROCERY_V2_ITEM_UPDATE_REQUEST,
    GROCERY_V2_ITEM_UPDATE_SUCCESS,
    GROCERY_V2_ITEM_UPDATE_FAIL,
    GROCERY_V2_ITEM_DELETE_REQUEST,
    GROCERY_V2_ITEM_DELETE_SUCCESS,
    GROCERY_V2_ITEM_DELETE_FAIL,
    GROCERY_V2_ITEM_UPDATE_MULTIPLE_REQUEST,
    GROCERY_V2_ITEM_UPDATE_MULTIPLE_SUCCESS,
    GROCERY_V2_ITEM_UPDATE_MULTIPLE_FAIL,
    GROCERY_V2_CATEGORY_GET_REQUEST,
    GROCERY_V2_CATEGORY_GET_SUCCESS,
    GROCERY_V2_CATEGORY_GET_FAIL,
    GROCERY_V2_CATEGORY_CREATE_REQUEST,
    GROCERY_V2_CATEGORY_CREATE_SUCCESS,
    GROCERY_V2_CATEGORY_CREATE_FAIL,
    GROCERY_V2_CATEGORY_UPDATE_REQUEST,
    GROCERY_V2_CATEGORY_UPDATE_SUCCESS,
    GROCERY_V2_CATEGORY_UPDATE_FAIL,
    GROCERY_V2_CATEGORY_DELETE_REQUEST,
    GROCERY_V2_CATEGORY_DELETE_SUCCESS,
    GROCERY_V2_CATEGORY_DELETE_FAIL,
    GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_REQUEST,
    GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_SUCCESS,
    GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_FAIL,
    GROCERY_V2_ITEM_DELETE_CHECKED_REQUEST,
    GROCERY_V2_ITEM_DELETE_CHECKED_SUCCESS,
    GROCERY_V2_ITEM_DELETE_CHECKED_FAIL,
    GROCERY_V2_ITEM_CHECK_REQUEST,
    GROCERY_V2_ITEM_CHECK_SUCCESS,
    GROCERY_V2_ITEM_CHECK_FAIL,
    GROCERY_V2_FAVORITES_GET_REQUEST,
    GROCERY_V2_FAVORITES_GET_SUCCESS,
    GROCERY_V2_FAVORITES_GET_FAIL,
    GROCERY_V2_FAVORITES_CREATE_REQUEST,
    GROCERY_V2_FAVORITES_CREATE_SUCCESS,
    GROCERY_V2_FAVORITES_CREATE_FAIL,
    GROCERY_V2_FAVORITES_DELETE_REQUEST,
    GROCERY_V2_FAVORITES_DELETE_SUCCESS,
    GROCERY_V2_FAVORITES_DELETE_FAIL,
    GROCERY_V2_UNDO_LIST_SUCCESS,
    GROCERY_V2_UNDO_LIST_FAIL
} from "../constants/groceryV2Constants";

// Item Actions
// `background: true` fetches silently — no spinner, and a failure leaves the current list alone.
export const loadGroceryV2Items = ({ background = false } = {}) => async(dispatch, getState) => {
    try {
        if (!background) dispatch({type: GROCERY_V2_ITEM_GET_REQUEST});

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.get(`/api/groceryv2/items`, config);

        dispatch({type: GROCERY_V2_ITEM_GET_SUCCESS, payload: data});

    } catch (error) {
        if (background) return;
        dispatch({
            type: GROCERY_V2_ITEM_GET_FAIL,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
    }
}

export const createGroceryV2Item = (text, category = null) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_ITEM_CREATE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.post("/api/groceryv2/items/create", { text, category }, config);

        dispatch({
            type: GROCERY_V2_ITEM_CREATE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_ITEM_CREATE_FAIL,
            payload: message,
        });
    }
}

export const updateGroceryV2Item = (id, text, position, category) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_ITEM_UPDATE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.put(`/api/groceryv2/items/update/${id}`, { text, position, category }, config);

        dispatch({
            type: GROCERY_V2_ITEM_UPDATE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_ITEM_UPDATE_FAIL,
            payload: message,
        });
    }
}

export const deleteGroceryV2Item = (id) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_ITEM_DELETE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        await axios.delete(`/api/groceryv2/items/delete/${id}`, config);

        dispatch({
            type: GROCERY_V2_ITEM_DELETE_SUCCESS,
            payload: id,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_ITEM_DELETE_FAIL,
            payload: message,
        });
    }
}

export const updateMultipleGroceryV2Items = (items) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_ITEM_UPDATE_MULTIPLE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.put(`/api/groceryv2/items/update-multiple`, { items }, config);

        dispatch({
            type: GROCERY_V2_ITEM_UPDATE_MULTIPLE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_ITEM_UPDATE_MULTIPLE_FAIL,
            payload: message,
        });
    }
}

export const checkGroceryV2Item = (id, currentChecked = false) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_ITEM_CHECK_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.put(`/api/groceryv2/items/update/${id}`, { isChecked: !currentChecked }, config);

        dispatch({
            type: GROCERY_V2_ITEM_CHECK_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_ITEM_CHECK_FAIL,
            payload: message,
        });
    }
}

export const deleteCheckedGroceryV2Items = () => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_ITEM_DELETE_CHECKED_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.delete(`/api/groceryv2/items/delete-checked`, config);

        dispatch({
            type: GROCERY_V2_ITEM_DELETE_CHECKED_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_ITEM_DELETE_CHECKED_FAIL,
            payload: message,
        });
    }
}

// Category Actions
export const loadGroceryV2Categories = ({ background = false } = {}) => async(dispatch, getState) => {
    try {
        if (!background) dispatch({type: GROCERY_V2_CATEGORY_GET_REQUEST});

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.get(`/api/groceryv2/categories`, config);

        dispatch({type: GROCERY_V2_CATEGORY_GET_SUCCESS, payload: data});

    } catch (error) {
        if (background) return;
        dispatch({
            type: GROCERY_V2_CATEGORY_GET_FAIL,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
    }
}

export const createGroceryV2Category = (name) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_CATEGORY_CREATE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.post("/api/groceryv2/categories/create", { name }, config);

        dispatch({
            type: GROCERY_V2_CATEGORY_CREATE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_CATEGORY_CREATE_FAIL,
            payload: message,
        });
    }
}

export const updateGroceryV2Category = (id, name, position) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_CATEGORY_UPDATE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.put(`/api/groceryv2/categories/update/${id}`, { name, position }, config);

        dispatch({
            type: GROCERY_V2_CATEGORY_UPDATE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_CATEGORY_UPDATE_FAIL,
            payload: message,
        });
    }
}

export const deleteGroceryV2Category = (id) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_CATEGORY_DELETE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        await axios.delete(`/api/groceryv2/categories/delete/${id}`, config);

        dispatch({
            type: GROCERY_V2_CATEGORY_DELETE_SUCCESS,
            payload: id,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_CATEGORY_DELETE_FAIL,
            payload: message,
        });
    }
}

export const updateMultipleGroceryV2Categories = (categories) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.put(`/api/groceryv2/categories/update-multiple`, { categories }, config);

        dispatch({
            type: GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_FAIL,
            payload: message,
        });
    }
}

// Favorites Actions
export const loadGroceryV2Favorites = ({ background = false } = {}) => async(dispatch, getState) => {
    try {
        if (!background) dispatch({type: GROCERY_V2_FAVORITES_GET_REQUEST});

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.get(`/api/groceryv2/favorites`, config);

        dispatch({type: GROCERY_V2_FAVORITES_GET_SUCCESS, payload: data});

    } catch (error) {
        if (background) return;
        dispatch({
            type: GROCERY_V2_FAVORITES_GET_FAIL,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
    }
}

export const createGroceryV2Favorite = (text) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_FAVORITES_CREATE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.post("/api/groceryv2/favorites/create", { text }, config);

        dispatch({
            type: GROCERY_V2_FAVORITES_CREATE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_FAVORITES_CREATE_FAIL,
            payload: message,
        });
    }
}

export const deleteGroceryV2Favorite = (text) => async(dispatch, getState) => {
    try {
        dispatch({
            type: GROCERY_V2_FAVORITES_DELETE_REQUEST,
        });

        const { userLogin: { userInfo }} = getState();

        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        };

        const { data } = await axios.delete("/api/groceryv2/favorites/delete", { ...config, data: { text } });

        dispatch({
            type: GROCERY_V2_FAVORITES_DELETE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_FAVORITES_DELETE_FAIL,
            payload: message,
        });
    }
}

// Undo Actions
export const updateGroceryV2UndoList = (item) => async(dispatch, getState) => {
    try {
        const { groceryV2UndoList: { undoList = [] } = {} } = getState();

        dispatch({
            type: GROCERY_V2_UNDO_LIST_SUCCESS,
            payload: undoList.concat(item),
        });

    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_UNDO_LIST_FAIL,
            payload: message,
        });
    }
}

export const removeGroceryV2UndoList = () => async(dispatch, getState) => {
    try {
        const { groceryV2UndoList: { undoList = [] } = {} } = getState();

        // Create a new array without the last item
        const newUndoList = undoList.slice(0, -1);

        dispatch({
            type: GROCERY_V2_UNDO_LIST_SUCCESS,
            payload: newUndoList,
        });

    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_UNDO_LIST_FAIL,
            payload: message,
        });
    }
}

export const updateGroceryV2UndoBatch = (items, categories = []) => async(dispatch, getState) => {
    try {
        const { groceryV2UndoList: { undoList = [] } = {} } = getState();

        // Add the batch as a single entry in the undo list
        dispatch({
            type: GROCERY_V2_UNDO_LIST_SUCCESS,
            payload: undoList.concat([{ type: 'batch', items, categories }]),
        });

    } catch (error) {
        const message = error.response && error.response.data.message ? error.response.data.message : error.message;
        dispatch({
            type: GROCERY_V2_UNDO_LIST_FAIL,
            payload: message,
        });
    }
}
